import React from "react";

import { OutputRow as MeetingRescheduleRequestsData } from "api/getMeetingRescheduleRequests";
import { formatMeetingRescheduleRequestDetails } from "services/formatMeetingRescheduleRequestDetails";
import { useDefaultTimezone } from "hooks/useDefaultTimezone";

import SimpleTable from "components/SimpleTable";

interface MeetingSummaryProps {
	event: MeetingRescheduleRequestsData;
	currentUid: string;
}

const RescheduleRequestSummary: React.FunctionComponent<
	MeetingSummaryProps
> = ({ event, currentUid }) => {
	const defaultTimezone = useDefaultTimezone();

	const {
		startDate,
		startTime,
		endTime,
		originalStartDate,
		originalStartTime,
		originalEndTime,
		partnersName,
		timezone
	} = formatMeetingRescheduleRequestDetails(
		event,
		currentUid,
		false,
		defaultTimezone
	);

	const rows = [
		[
			<strong>Old date and time</strong>,
			`${originalStartDate} at ${originalStartTime} until ${originalEndTime} (${timezone})`
		],
		[
			<strong>New date and time</strong>,
			`${startDate} at ${startTime} until ${endTime} (${timezone})`
		],
		[<strong>With</strong>, partnersName]
	];

	return <SimpleTable rows={rows} />;
};

export default RescheduleRequestSummary;
